import { render, staticRenderFns } from "./wrap.vue?vue&type=template&id=bd1e15f2&scoped=true&"
import script from "./wrap.vue?vue&type=script&lang=js&"
export * from "./wrap.vue?vue&type=script&lang=js&"
import style0 from "./wrap.vue?vue&type=style&index=0&id=bd1e15f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1e15f2",
  null
  
)

export default component.exports